module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_bangdan.7fa66.png";